import { toast } from '@/components/toast';
import { deleteVoice } from '@/services/api';
import { logger } from '@/services/logger';
import { ALL_VOICES_ID } from '@/state/presenters';
import { useMutation, useQueryClient } from 'react-query';

export function useDeleteVoiceMutation(skipToast?: boolean) {
    const queryClient = useQueryClient();
    return useMutation(deleteVoice, {
        onError: async (err: any, id) => {
            if (err.response.status !== 404) {
                logger.error(`Could not delete voice ${id}`, { err });
                if (!skipToast) {
                    toast.error({ title: `Could not delete voice`, toastId: `delete-voice-error` });
                }
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ALL_VOICES_ID });
            if (!skipToast) {
                toast.success({ title: 'Your voice was successfully deleted' });
            }
        },
    });
}
